import React, { useState, useRef, useEffect } from 'react';
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,
} from "reactstrap";
import { Field, Formik } from "formik";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import useContextService from 'hooks/useContextService';
import ThirdPartyAdmin from "components/ThirdPartyAdmin";
import useAxios from 'hooks/useAxios';
import { cloneDeep, find } from 'lodash';
import * as Yup from "yup";
import { default as ReactSelect } from "react-select";
import { Option, LimitedChipsContainer } from "components/Options";
import reset from "../../../assets/icon/reset.svg"
import searchicon from "../../../assets/icon/search.svg"

const validationSchema = Yup.object({
  thirdPartyAdminID: Yup.string().required(
    "Third Party Administrator is required"
  ),
});

const dateRangeOption = [
  { id: 1, label: "Last 30 Days" },
  { id: 2, label: "Last 90 Days" },
  { id: 3, label: "Last 180 Days" },
  { id: 4, label: "Last 365 Days" },
];

let ceData = [];
let pharmacyData = [];

const SearchDashBoard = (props) => {
  const API = useAxios();
  const formikRef = useRef();
  const {
    states: { dashboard },
    setStates,
    resetStates,
  } = useContextService();
  const { onSearch, onReset } = props;

  const { thirdPartyAdmin, searchTerms } =
    dashboard;
  const {
    thirdPartyAdminID,
    dateRangeID,
  } = searchTerms;

  const { tenantID } = thirdPartyAdmin;

  const [dateRangeValue, setDateRangeValue] = useState(4);
  const [ceDatalist, setCeDatalist] = useState([]);
  const [selectedOption, setOptionSelected] = useState({
    optionSelected: "-1",
  });
  const [selectedOpt, setOptSelected] = useState({ optSelected: "-1" });


  const updateStates = (dashboard) => {
    setStates('dashboard', dashboard);
  };

  useEffect(() => {
    dashboard.thirdPartyAdmin = {};
    dashboard.thirdPartyAdminID = '';
    dashboard.selectedDateRange = {};
    setDateRangeValue(4);
    resetStates('dashboard');
    dashboard.searchTerms.ceIds = {};
    dashboard.searchTerms.pharmacyids = {};
  }, []);

  const handleDateRangeChange = ({ target: { value } }, setFieldValue) => {
    if (value) {
      const statusID = parseInt(value);
      const findObj = find(dateRangeOption, {
        id: statusID,
      });
      dashboard.selectedDateRange = findObj;
      dashboard.searchTerms.dateRangeID = findObj.id;
      setFieldValue('dateRangeID', findObj.id);
      setDateRangeValue(value.id)
    } else {
      dashboard.selectedDateRange = {};
      dashboard.searchTerms.dateRangeID = '';
      setFieldValue('dateRangeID', 4);
      setDateRangeValue(4)

    }
    updateStates(dashboard);
  }

  const fetchPharmacyNamesByTpaID = async (thirdPartyAdminID) => {
    pharmacyData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/GetPharmaciesByTpaId/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };




  const fetchPharmacyNames = async (selected) => {
    let payloads = [];
    pharmacyData = [];
    for (var x in selected) {
      var rw = selected[x];
      payloads.push(rw.value);
    }
    let payload = {};
    payload.CoveredIDS = payloads;
    try {
      const { data } = await API.post(
        `GWConfig/coveredentity/Pharmacieslist/${thirdPartyAdminID}`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchCoveredEntities = async (thirdPartyAdminID) => {
    setCeDatalist([]);
    ceData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/CElist/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          ceData.push({ value: data[x].id, label: data[x].description });
        }
        setCeDatalist(ceData);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleCEChange = (selected) => {
    setOptSelected({ optSelected: "-1" });
    pharmacyData = [];
    if (selected.length !== 0) {
      setOptSelected({
        optSelected: -1,
      });
    }
    if (selected.length === 0) {
      fetchPharmacyNamesByTpaID(thirdPartyAdminID);
    }
    pharmacyData = [];
    setOptionSelected({
      optionSelected: selected,
    });
    dashboard.searchTerms.ceIds = selected;
    updateStates(dashboard);
    fetchPharmacyNames(selected);
  };

  const handlepharmacyChange = (selected) => {
    setOptSelected({
      optSelected: selected,
    });
    dashboard.searchTerms.pharmacyids = selected;
    updateStates(dashboard);
  };

  const handleSubmit = async (val, actions) => {

    let coveredEntityIDS = [];
    for (var x in selectedOption.optionSelected) {
      var n = selectedOption.optionSelected[x].value;
      coveredEntityIDS.push(n);
    }
    let pharmacyIDS = [];
    for (var x in selectedOpt.optSelected) {
      var rw = selectedOpt.optSelected[x].value;
      pharmacyIDS.push(rw);
    }

    const values = cloneDeep(val);
    if (thirdPartyAdminID) values.thirdPartyAdminID;
    if (coveredEntityIDS > [0]) values.coveredEntityIDS = coveredEntityIDS;
    if (pharmacyIDS > [0]) { values.pharmacyIDS = pharmacyIDS; }
    else {
      values.pharmacyIDS = [];
    }
    const { setSubmitting } = actions;
    // const values = cloneDeep(val);
    dashboard.search.currentPage = 1;
    updateStates(dashboard);
    await onSearch(values);
    setSubmitting(false);
  };

  const handleThirdPartyAdminChange = async (value, setFieldValue, tpa) => {
    setOptSelected({ optSelected: "-1" });
    setOptionSelected({ optionSelected: "-1" });
    setDateRangeValue(4);
    setCeDatalist([]);
    pharmacyData = [];
    ceData = [];
    if (tpa) {
      const { thirdPartyAdminID } = tpa;
      setFieldValue('thirdPartyAdminID', value);
      dashboard.thirdPartyAdmin = tpa;
      dashboard.searchTerms.thirdPartyAdminID = thirdPartyAdminID;
      fetchCoveredEntities(thirdPartyAdminID);
      fetchPharmacyNamesByTpaID(thirdPartyAdminID)
    } else {
      setFieldValue('thirdPartyAdminID', '');
      dashboard.thirdPartyAdmin = {};
      dashboard.searchTerms.thirdPartyAdminID = '';
      pharmacyData = [];
      ceData = [];
    }
    updateStates(dashboard);
  };

  const handleReset = ({ resetForm }) => {
    dashboard.thirdPartyAdmin = {};
    dashboard.thirdPartyAdminID = '';
    dashboard.selectedDateRange = {};
    setOptSelected({ optSelected: "-1" });
    dashboard.searchTerms.ceIds = {};
    dashboard.searchTerms.pharmacyids = {};
    setOptionSelected({ optionSelected: "-1" });
    resetForm();
    onReset();
    pharmacyData = [];
    ceData = [];
    setDateRangeValue(4);
    resetForm();
    onReset();
    resetStates('dashboard');
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={searchTerms}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize={true}
      children={(props) => {
        const { isSubmitting, handleSubmit, resetForm, setFieldValue } = props;
        return (
          <div>
            <h5 className="f-15 text-primary font-weight-700">Dashboard</h5>
            <Row>
              <Col md={3} sm={3} xs={3}>
                {" "}
                <FormGroup>
                  <Label for="tpa">Third Party Administrator</Label>
                  <ThirdPartyAdmin
                    value={thirdPartyAdminID}
                    name="thirdPartyAdminID"
                    onChange={(value, tpa) =>
                      handleThirdPartyAdminChange(value, setFieldValue, tpa)
                    }
                  />
                </FormGroup>
              </Col>

              <Col md={3} sm={3} xs={3}>
                <FormGroup>

                  <FormGroup>
                    <Label for="coveredEntity">Covered Entity</Label>

                    <ReactSelect
                      name="ceDatalist"
                      options={ceDatalist}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      optionSelected={true}
                      placeholder = "(All)"
                      components={{
                        Option,
                        ValueContainer: LimitedChipsContainer,
                      }}
                      isSearchable="true"
                      onChange={handleCEChange}
                      value={selectedOption.optionSelected}
                      className="claim_info"
                      maxMenuHeight={220}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 99,
                        }),
                        option: (provided) => ({
                          ...provided,
                          display: 'flex',
                          alignItems: 'flex-start',
                        })
                      }}
                    />
                  </FormGroup>




                </FormGroup>
              </Col>

              <Col md={3} sm={3} xs={3}>
                {" "}
                <FormGroup>
                  <Label for="pharmacy">Pharmacy</Label>

                  <ReactSelect
                    name="pharmacyData"
                    options={pharmacyData}
                    isMulti
                    closeMenuOnSelect={false}
                    placeholder = "(All)"
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handlepharmacyChange}
                    value={selectedOpt.optSelected}
                    className="claim_info"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option: (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />


                </FormGroup>
              </Col>{" "}

              <Col md={3} sm={3} xs={3}>
                <Label for="dateRange">Date Range</Label>
                <Field
                  id="dateRange"
                  name="dateRange"
                  className="requiredS"
                  type="text"
                  component={FormikSelectField}
                  options={dateRangeOption}
                  value={dateRangeValue}
                  onChange={(val) => handleDateRangeChange(val, setFieldValue)}
                  defaultoption="--Select--"
                  keys={{
                    id: "id",
                    label: "label",
                  }}
                />
              </Col>
            </Row>

            <Row className="d-flex justify-content-end">
              <Col md="auto" className="">
                <Label>{""}</Label>
                <Button
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                  color="primary"
                  className="search"

                >
                  <span className="right_5">
                    <img src={searchicon} alt="" />
                  </span>{" "}
                  Search
                </Button>
                <Button className="reset" color="primary" onClick={() => handleReset(props)}>
                  <span className="right_5">
                    <img src={reset} alt="" />
                  </span>{" "}
                  Reset
                </Button>
              </Col>
            </Row>

          </div>
        );
      }}
    ></Formik>
  );
};

export default SearchDashBoard;